const env = (name, fallback) => {
  const value = process.env[name]
  if (value === undefined || String(value).trim() === '') return fallback
  return value
}

const nameArFull = env('VUE_APP_HOSPITAL_NAME_AR_FULL', 'نظام إدارة المستشفيات')
const nameArShort = env('VUE_APP_HOSPITAL_NAME_AR_SHORT', 'نظام إدارة المستشفيات')

const logoFile = env('VUE_APP_HOSPITAL_LOGO', '')
const publicUrl = env('VUE_APP_PUBLIC_URL', '')
// eslint-disable-next-line global-require
const genericLogo = require('@/assets/images/logo/his-generic.svg')

const hospitalBranding = {
  nameArFull,
  nameArShort,
  nameArWithNumber: env('VUE_APP_HOSPITAL_NAME_AR_WITH_NUMBER', nameArShort),
  nameArReport: env('VUE_APP_HOSPITAL_NAME_AR_REPORT', nameArFull),
  districtAr: env('VUE_APP_HOSPITAL_DISTRICT_AR', ''),
  districtEn: env('VUE_APP_HOSPITAL_DISTRICT_EN', ''),
  nameEnFull: env('VUE_APP_HOSPITAL_NAME_EN_FULL', 'Hospital Information System'),
  nameEn: env('VUE_APP_HOSPITAL_NAME_EN', 'Hospital Information System'),
  brandNameEn: env('VUE_APP_BRAND_NAME_EN', 'Hospital Information System'),
  nameEnPrint: env('VUE_APP_HOSPITAL_NAME_EN_PRINT', 'HOSPITAL INFORMATION SYSTEM'),
  addressAr: env('VUE_APP_HOSPITAL_ADDRESS_AR', ''),
  addressEn: env('VUE_APP_HOSPITAL_ADDRESS_EN', ''),
  phone: env('VUE_APP_HOSPITAL_PHONE', ''),
  phone2: env('VUE_APP_HOSPITAL_PHONE_2', ''),
  email: env('VUE_APP_HOSPITAL_EMAIL', ''),
  logo: logoFile ? `${process.env.BASE_URL}${logoFile}` : genericLogo,
}

if (publicUrl) {
  hospitalBranding.publicUrl = publicUrl.replace(/\/+$/, '')
} else {
  Object.defineProperty(hospitalBranding, 'publicUrl', {
    enumerable: true,
    get() {
      return typeof window === 'undefined' ? '' : window.location.origin
    },
  })
}

export default Object.freeze(hospitalBranding)
